// unMachine filter.
const unMachine = value => value.replace(/-/g, " ");

export { unMachine };